/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Badge_FastInputs */

const en_model_badge_fast = /** @type {(inputs: Model_Badge_FastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fast`)
};

const id_model_badge_fast = /** @type {(inputs: Model_Badge_FastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cepat`)
};

/**
* | output |
* | --- |
* | "Fast" |
*
* @param {Model_Badge_FastInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_badge_fast = /** @type {((inputs?: Model_Badge_FastInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Badge_FastInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_badge_fast(inputs)
	return en_model_badge_fast(inputs)
});